module.exports = __webpack_public_path__ + "static/media/oberflex-movinguimoire-2560x1440.997743e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-movinguimoire-2560x1440.jpg
// module id = 1035
// module chunks = 37